module.exports = __webpack_public_path__ + "static/globe-cd29c1f19c94f1b3f8c6b7e67ba6bf64.png";